import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

export default function MenuManager() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMenu();
  }, []);

  const fetchMenu = async () => {
    try {
      const res = await axios.get(`${API}/admin/menu`);
      setItems(res.data.items || []);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError('Failed to load menu');
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/admin/menu/save`, { items }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Menu saved successfully!');
    } catch (err) {
      console.error(err);
      alert('Failed to save menu');
    }
    setSaving(false);
  };

  const addItem = () => {
    setItems([...items, { id: Date.now().toString(), label: 'New Link', url: '/', type: 'link', children: [] }]);
  };

  const removeItem = (index) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  const updateItem = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
  };

  if (loading) return <div>Loading menu...</div>;

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <h2 className="text-2xl font-bold mb-4">Navigation Menu Manager</h2>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      
      <div className="space-y-4 mb-6">
        {items.map((item, index) => (
          <div key={item.id} className="p-4 border rounded bg-gray-50 flex flex-col gap-3">
            <div className="flex items-center gap-4">
              <span className="font-bold text-gray-500">#{index + 1}</span>
              <div className="flex-1">
                <label className="block text-xs text-gray-500 font-bold mb-1">Label</label>
                <input
                  type="text"
                  value={item.label}
                  onChange={(e) => updateItem(index, 'label', e.target.value)}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div className="flex-1">
                <label className="block text-xs text-gray-500 font-bold mb-1">URL / Slug</label>
                <input
                  type="text"
                  value={item.url || ''}
                  onChange={(e) => updateItem(index, 'url', e.target.value)}
                  className="w-full p-2 border rounded"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 font-bold mb-1">Type</label>
                <select
                  value={item.type}
                  onChange={(e) => updateItem(index, 'type', e.target.value)}
                  className="w-full p-2 border rounded"
                >
                  <option value="link">Link</option>
                  <option value="dropdown">Dropdown</option>
                </select>
              </div>
              <div className="pt-5">
                <button
                  onClick={() => removeItem(index)}
                  className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-gray-500 italic">No menu items yet.</div>}
      </div>

      <div className="flex gap-4">
        <button
          onClick={addItem}
          className="bg-blue-100 text-blue-700 px-4 py-2 rounded font-bold hover:bg-blue-200"
        >
          + Add Menu Item
        </button>
        <button
          onClick={handleSave}
          disabled={saving}
          className="bg-green-600 text-white px-6 py-2 rounded font-bold hover:bg-green-700 disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Menu'}
        </button>
      </div>
    </div>
  );
}

